import styled, { css } from "styled-components";

export const Wrapper = styled.div`
	width: 550px;
	height: 100%;
`;
export const Content = styled.div`
	margin-left: 50px;
	margin-right: 50px;
	margin-top: 64px;
`;
export const Header = styled.div`
	margin-left: 6px;
	margin-right: 3px;
	margin-bottom: 56px;
	display: flex;
	align-items: center;
`;
export const Name = styled.h1`
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 32px;
	padding-right: 24.58px;
`;
// export const Status = styled.span`
// 	font-weight: 400;
// 	font-size: 13px;
// 	line-height: 20px;
// 	color: #002e5c;
// 	padding-left: 6.58px;
// 	img {
// 		padding-left: 12.85px;
// 	}
// `;

export const Status = styled.div`
  padding-left: 9.08px;
  padding-top: 5.58px;
  padding-bottom: 5.58px;
  padding-right: 8.5px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  width: fit-content;
  text-transform: capitalize;

  ${(props) => {
    switch (props.type) {
		
		case "partially-paid": return   css`
           color: var(--Pink-100, #FA3372);
        background: var(--Pink-10, #FFF5F8);
		`
		case "open":
        return css`
          color: var(--Orange-100, #f57c00);
          background: var(--Orange-20, #fff3e0);
        `;
		  case "closed":
        return css`
       color: var(--Blue-100, #2555EF);
        background: var(--Blue-20, #EAEEFC);
        `;
		case "paid": return   css`
        color: var(--Blue-100, #2555EF);
        background: var(--Blue-20, #EAEEFC);
      `
    case "pending": return css`
         color: var(--Pink-100, #FA3372);
        background: var(--Pink-10, #FFF5F8);
              `
      case "sent":
        return css`
          color: var(--Blue-100, #2555ef);
          background: var(--Blue-20, #eaeefc);
        `;
      case "opened":
        return css`
          color: var(--Indigo-100, #4b3ecf);
          background: var(--Indigo-20, #eae9fb);
        `;
      case "clicked":
        return css`
          color: var(--Purple-100, #7a3fd3);
          background: var(--Purple-20, #f1e9fb);
        `;
      case "completed":
        return css`
          color: var(--Green-100, #2e7d32);
          background: var(--Green-20, #e6f4ea);
        `;

    
      default:
        return css`
          color: var(--Gray-100, #6b7280);
          background: var(--Gray-20, #f3f4f6);
        `;
    }
  }}
`;
export const ButtonGroup = styled.div`
	width: 180px;
	height: 48px;
	padding-left: 93px;
	display: flex;
`;
export const Cancel = styled.button`
	text-align: left;
	align-items: left;
	color: #2555ef;
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
	background-color: transparent;
	padding-right: 21px;
`;
export const Save = styled.button`
	text-align: center;
	background: #2555ef;
	border-radius: 5px;
	padding: 8px 20px;
	color: #ffffff;
`;
export const TabPanel = styled.div`
	display: flex;
	font-size: 16px;
	line-height: 24px;
	margin-bottom: 28px;
`;
export const StatusTab = styled.button`
	background-color: transparent;
	border: none;
	padding-bottom: 10px;
	width: 352px;
	border-bottom: ${(props) => (props.tabType === "Status" ? "3px solid #2555EF" : " 1px solid #B5B5C3")};
	color: ${(props) => (props.tabType === "Status" ? "#002E5C" : "#B5B5C3")};
	font-weight: ${(props) => props.tabType === "Status" && "bold"};
	opacity: ${(props) => props.tabType !== "Status" && "0.3"};
`;
export const UserDetailsTab = styled.button`
	background-color: transparent;
	border: none;
	padding-bottom: 10px;
	width: 352px;
	border-bottom: ${(props) => (props.tabType === "User Details" ? "3px solid #2555EF" : " 1px solid #B5B5C3")};
	color: ${(props) => (props.tabType === "User Details" ? "#002E5C" : "#B5B5C3")};
	font-weight: ${(props) => props.tabType === "User Details" && "bold"};
	opacity: ${(props) => props.tabType !== "User Details" && "0.3"};
`;
export const TabContent = styled.div``;
export const VerticalLine = styled.div`
	width: 1px;
	height: 20px;
	float: left;
	border: 1px ridge rgba(0, 46, 92, 0.2);
	border-radius: 1px;
`;

// Status Tab Component
export const StatusWrapper = styled.div``;
export const FirstRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
export const StatusItems = styled.div`
	color: #002e5c;
	width: 323px;
	font-weight: 400;
	font-size: 12px;
	line-height: 18px;
	margin-right: 28px;
	p {
		display: flex;
		justify-content: space-between;
		align-items: center;
		span {
			font-weight: bold;
		}
	}
	div {
		width: 100%;
		height: 54px;
		background: rgba(0, 46, 92, 0.05);
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		padding-top: 18px;
		padding-bottom: 15px;
		padding-left: 9%;
		margin-top: 7px;
		img {
			padding-right: 20px;
			height: 19px;
		}
	}
`;
export const RemainingPayment = styled.div`
	width: 323px;
	font-weight: 400;
	font-size: 12px;
	line-height: 18px;
	color: #002e5c;
	p {
		display: flex;
		justify-content: space-between;
		align-items: center;
		span {
			font-weight: bold;
		}
	}
	div {
		width: 100%;
		height: 54px;
		background: rgba(0, 46, 92, 0.05);
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		padding-top: 18px;
		padding-bottom: 15px;
		padding-left: 25.74px;
		margin-top: 7px;
		img {
			padding-right: 20px;
			height: 19px;
		}
	}
`;
export const SecondRow = styled.button`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 9px 18px;
	background-color: #d3ddfc;
	border-radius: 4px;
	height: 42px;
	width: 100%;
	color: #2555ef;
	font-size: 14px;
	line-height: 21px;
	font-weight: 400;
	margin-top: 21px;
	margin-bottom: 26px;
	img {
		margin-right: 8.63px;
	}
`;
export const DropDownContainer = styled("div")`
	width: 100%;
	margin: 0 auto;
`;

export const DropDownHeader = styled("div")`
	padding-top: 19px;
	padding-bottom: 17px;
	padding-left: 24px;
	width: 100%;
	height: 54px;
	background: rgba(0, 46, 92, 0.05);
	border: 1px solid #2555ef;
	border-radius: 4px;
	color: ${(props) =>
		props.value === "Approve"
			? "#002E5C"
			: props.value === "Pending"
			? "#FA3372"
			: props.value === "On Hold"
			? "#EEA448"
			: "#002E5C"};
	font-size: 14px;
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	img {
		position: absolute;
		right: 23.92px;
		top: 45%;
	}
`;

export const DropDownListContainer = styled("div")``;

export const DropDownList = styled("ul")`
	padding: 0;
	margin: 0;
	background: #ffffff;
	border: 1px solid #e5e5e5;
	box-sizing: border-box;
	color: #3faffa;
	font-size: 1.3rem;
	font-weight: 500;
	margin-top: 7px;
	&:first-child {
		padding-top: 0.8em;
	}
`;

export const ListItem = styled("li")`
	list-style: none;
	padding-left: 30px;
	width: 100%;
	height: 53px;
	display: flex;
	align-items: center;
	color: ${(props) => props.textColor};
	&:hover {
		background-color: #e5e5e5;
		cursor: pointer;
	}
`;

export const Description = styled.div`
	margin-top: 38px;
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
	color: #002e5c;
	p {
		margin-bottom: 7px;
	}
	span {
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		opacity: 0.7;
		margin-bottom: 7px;
	}
`;
export const Update = styled.div`
	display: flex;
	span {
		padding-left: 6px;
		font-weight: 400;
		font-size: 12px;
		line-height: 15px;
		color: #b5b5c3;
		padding-top: 5px;
	}
`;
export const NewFieldButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;
	width: 100%;
	height: 54px;
	border: 1px dashed rgba(0, 46, 92, 0.2);
	border-radius: 4px;
	color: #002e5c;
	padding: 9px 18px;
	gap: 6px;
	margin-top: 30px;
`;
export const Files = styled.ul`
	margin-top: 10px;
	li {
		padding-bottom: 15px;
		width: 100%;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		cursor: pointer;
		font-weight: bold;
	}
`;
// Form Viewr Component

export const FormWrapper = styled.div`

`;
export const FormTitleSection = styled.div`
	display: flex;
	height: 100px;
	padding: 10px;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 10px;
	margin-top: 30px;
	align-self: stretch;
	border-radius: 10px;
	border-bottom: 1px solid rgba(0, 46, 92, 0.2);
	background: #f3f6f9;
	span {
		color: #2555ef;
		font-size: 31px;
		font-style: normal;
		font-weight: bold;
		line-height: 32px;
		padding-top: 10px;
		padding-left: 31px;
	}
`;

export const FormSection = styled.div`
	position: relative;
	display: flex;
	width: 806px;
	height: fit-content;
	justify-content: center;
	align-items: center;
	border-radius: 10px;
	background: #f3f6f9;
	margin-top: 50px;
`;
export const FormContant = styled.div`
	width: 616px;
	padding-top: 30px;
	padding-bottom: 30px;

	hr {
		width: 100%;
	}




	.react-form-builder-form .rfb-item::after {
		content: "";
		background: rgba(0, 0, 0, 0.1);
		position: absolute;
		width: 100%;
		height: 1px;
		bottom: 0;
		left: 0;
	}
	.react-form-builder-form .rfb-item label span {
		color: rgb(0, 46, 92);
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		background: none;
		position: relative;
		width: fit-content;
		height: fit-content;
		padding: 0;
	}
  .react-form-builder-form .rfb-item label .label-required  {
    margin-left: 10px;
    font-size: 10px;
  }
	.react-form-builder-form .rfb-item .form-control {
		height: 48px;
		border-radius: 6px;
		background: rgb(255, 255, 255);
	}

	.react-form-builder-form .rfb-item .react-datepicker-wrapper {
		width: 100%;
	}
	.react-form-builder-form .rfb-item .react-datepicker__close-icon::after {
		font-size: 11px;
	}

  .react-form-builder-form .btn-toolbar {
    width: 100%;
  }
	.image-upload-container .image-upload {
		pointer-events: none;
	}

	.image-upload-container .btn {
		cursor: pointer;
		pointer-events: none;
	}

	@media only screen and (max-width: 768px) {
		.react-form-builder-form .rfb-item {
			width: 100%;
		}
	}
`;
export const Label = styled.label`
	color: #002e5c;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-transform: capitalize;
`;
export const DateIcon = styled.img`
	position: absolute;
	right: 15px;
	bottom: 14px;
`;
export const CheckBoxGroup = styled.div`
	width: 600px;
	display: flex;
	flex-flow: row wrap;
	position: relative;
`;
export const Item = styled.div`
	margin: 4px;
	margin-bottom: 29px;
	flex: 0 1 calc(20% - 8px); /* <-- adjusting for margin */
`;
export const DatePickerWrapper = styled.div`
	position: relative;

	div {
		div.react-datepicker__input-container input {
			width: 45em;
			border: none;
			background-color: #fff;
			border-radius: 5px;
			color: #3f4254;
			padding-inline: 10px;
		}
	}
`;

export const FormEditButton = styled.div`
	position: absolute;
	right: 6px;
	top: 6px;
  cursor: pointer;
`;

